/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './Deductibles.scss'
import { CommonUtils } from '../../../../utils/CommonUtils'
import NumberFormat from 'react-number-format'
import { IDeductibles } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface IDeductiblesProps {
	data: IDeductibles
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IDeductiblesState {}

export class DeductiblesComponent extends React.Component<IDeductiblesProps, IDeductiblesState> {
	constructor(props: Readonly<IDeductiblesProps>) {
		super(props)
	}

	render(): React.ReactNode {
		const deductiblesModel = this.props.data

		let episodesSeed = 1
		const episodesCount = deductiblesModel.episodes.length

		const getEpisodes = deductiblesModel.episodes
			.sort((o1, o2) => CommonUtils.compareProperty(o2.startDate, o1.startDate))
			.map((element, index) => {
				const classBorder = episodesSeed++ === episodesCount ? 'bottom-border-td' : ''
				return (
					<tr key={index}>
						<td>{deductiblesModel.episodeDefinition}: </td>
						<td className={classBorder}>{CommonUtils.DateRange(element.startDate, element.endDate)}</td>
						<td className={classBorder} colSpan={2}>
							Deductible Remaining: <strong>{element.remaining}</strong>
						</td>
					</tr>
				)
			})

		let schedulesSeed = 1
		const schedulesCount = deductiblesModel.schedules.length

		const getSchedules = deductiblesModel.schedules
			.sort((o1, o2) => CommonUtils.compareProperty(o2.startDate, o1.startDate))
			.map((element, index) => {
				const classBorder = schedulesSeed++ > schedulesCount - 1 ? 'bottom-border-td' : ''
				return (
					<tr key={index}>
						<td>{CommonUtils.DateRange(element.startDate, element.endDate, true)}:</td>
						<td className={classBorder} colSpan={3}>
							{element.total !== 0 || !element.hasRemaining ? (
								<span>
									Base Deductible:
									<strong>
										<NumberFormat value={element.total} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={'$'} renderText={(value: string): JSX.Element => <span>{value}</span>} />
									</strong>
									&nbsp;&nbsp;&nbsp;
								</span>
							) : (
								<></>
							)}
							{element.hasRemaining && element.total !== element.remaining ? (
								<span>
									Deductible Remaining:
									<strong>
										<NumberFormat value={element.remaining} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={'$'} renderText={(value: string): JSX.Element => <span>{value}</span>} />
									</strong>
								</span>
							) : (
								<></>
							)}
						</td>
					</tr>
				)
			})
		return (
			<>
				{getSchedules}
				{getEpisodes}
			</>
		)
	}
}
